// @flow

import * as React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Mutation } from 'react-apollo';
import Button from 'react-bootstrap/lib/Button';
import Panel from 'react-bootstrap/lib/Panel';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';

import { loginMutation } from '../../../graphql/mutations/auth';
import Alert from '../../../components/Alert';
import Modal from '../../../components/Modal';
import InputField from '../../../components/InputField';
import ErrorParser from '../../../components/ErrorParser';
import { DesktopView, MobileView } from '../../../config/mediaQuery';

const SignInSchema = Yup.object().shape({
  username: Yup.string().required('Required'),
  password: Yup.string().required('Required'),
});

type Props = {
  history: any,
};

type State = {
  error: ?{},
  rememberMe: boolean,
};

type Response = {
  data: {
    login: ?{
      token: string,
      redirect: string,
      state: string,
    },
  },
};

type LoginMutation = ({}) => Promise<Response>;
type Values = {
  username: string,
  password: string,
  rememberMe: boolean,
  state: string,
};

export default class LoginForm extends React.PureComponent<Props, State> {
  state = {
    error: null,
    rememberMe: false,
  };

  saveUserInfo(values: Values) {
    const { username, password } = values
    localStorage.setItem( "userInfo", JSON.stringify({ username, password }))
  }

  onSubmitForm = (mutation: LoginMutation, values: Values) => {
    const { history } = this.props;
    this.saveUserInfo(values)

    mutation({
      variables: {
        input: {
          rememberMe: this.state.rememberMe,
          ...values,
        },
      },
    })
      .then((response: Response) => {
        const {
          data: { login },
        } = response;

        this.setState(() => ({
          error: null,
        }));

        if (login) {
          const { redirect } = login;

          history.replace(redirect);
        }
      })
      .catch(e => {
        this.setState(() => ({
          error: e.message,
        }));
      });
  };

  getLoginForm = (errors, touched, isValid, options, loginUser, values) => {
    return (
      <Form>
      <InputField
        label="Username"
        name="username"
        placeholder="Enter Username"
        errors={errors}
        touched={touched}
      />
      <InputField
        label="Password"
        name="password"
        placeholder="Enter Password"
        type="password"
        errors={errors}
        touched={touched}
      />
    <MobileView>
      {( matches ) => {
          return (
            <Button
              type="submit"
              onClick={() =>
                isValid &&
                !options.data &&
                // $FlowFixMe
                this.onSubmitForm(loginUser, values)
              }
              bsStyle="primary"
              {...matches ? { bsClass:'login-button' } : {}}
            >
              Submit
            </Button>
          )
        }
      }
    </MobileView>

    </Form>
    )
  }


  render() {
    return (
      <Formik
        initialValues={{
          username: '',
          password: '',
        }}
        validationSchema={SignInSchema}
        onSubmit={() => {}}
      >
        {({ errors, touched, isValid, values }) => (
          <Mutation
            mutation={loginMutation}
            errorPolicy="none"
            refetchQueries={() => {
              return ['IsLoggedIn']
            }}
          >
            {(loginUser, options: any) => (
              <React.Fragment>
                {options.loading && (
                  <Modal show={options.loading} backdrop="static">
                    <Modal.Header>
                      <Modal.Title>Loading, please wait.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <ProgressBar active now={100} />
                    </Modal.Body>
                  </Modal>
                )}
                {options.error && (
                  <Alert
                    show={
                      this.state.error !== null && options.loading === false
                    }
                  >
                    <h4>Error:</h4>
                    <ErrorParser error={options.error}>
                      {err => err.map(e => <p key={e}>{e}</p>)}
                    </ErrorParser>
                  </Alert>
                )}
                <DesktopView>
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title componentClass="h3">Sign In</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      {this.getLoginForm(errors, touched, isValid, options, loginUser, values)}
                    </Panel.Body>
                  </Panel>
                </DesktopView>
                <MobileView>
                  <div className='mobile-login-form'>
                    <h1>Welcome!</h1>
                    <p>Please, log in to your account</p>
                    {this.getLoginForm(errors, touched, isValid, options, loginUser, values)}
                  </div>
                </MobileView>
              </React.Fragment>
            )}
          </Mutation>
        )}
      </Formik>
    );
  }
}
